import React from "react";
import { Row, Col, Badge, Table } from "antd";
import PreviewDrawer from "../../../Common/PreviewDrawer";
import { Logger } from "../../../../hooks/api/loggers";
import { dateTimeFormat } from "../../../../contstant";
import dayjs from "dayjs";
import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";
import { UserRoleDisplay } from "../../../../enums/user";

interface LogHistoryViewProps {
  open: boolean;
  onClose: () => void;
  data: Logger | null;
}

export default function LogHistoryViewModal(props: LogHistoryViewProps) {
  const { open, onClose, data } = props;
  const { t } = useTranslation();

  if (!data) return null;

  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
      onCell: () => ({
        style: {
          backgroundColor: "var(--ant-color-fill-alter)",
          fontWeight: 500,
        },
      }),
    },
    {
      title: "Before",
      dataIndex: "before",
      key: "before",
      render: (value: string, record: any) => value || "-",
    },
    {
      title: "After",
      dataIndex: "after",
      key: "after",
      render: (value: string, record: any) => {
        if (record.field === "Status" && value) {
          return (
            <>
              <Badge status="success" />
              <span style={{ marginLeft: 8 }}>{value}</span>
            </>
          );
        }
        return value || "-";
      },
    },
  ];

  const tableData = [
    { field: "Email", before: data.before?.email, after: data.after?.email },
    {
      field: "Role",
      before: data.before?.role ? UserRoleDisplay[data.before.role] : undefined,
      after: data.after?.role ? UserRoleDisplay[data.after.role] : undefined,
    },
    {
      field: "Status",
      before: data.data?.status as string,
      after: data.data?.status as string,
    },
  ];

  return (
    <PreviewDrawer
      title={t("pages.logHistory.viewEntry")}
      open={open}
      onClose={onClose}
    >
      <div className={styles.container}>
        <Row className={styles.row}>
          <Col span={4} className={styles.label}>
            Modifier
          </Col>
          <Col span={20} className={styles.value}>
            <span className={styles.link}>{data.user?.fullName}</span>
          </Col>
        </Row>

        <Row className={styles.row}>
          <Col span={4} className={styles.label}>
            Date
          </Col>
          <Col span={20} className={styles.value}>
            {dayjs(data.createdAt).format(dateTimeFormat)}
          </Col>
        </Row>

        <Row className={styles.row}>
          <Col span={4} className={styles.label}>
            Entity
          </Col>
          <Col span={20} className={`${styles.value} capitalize-first-letter`}>
            {data.entity}
          </Col>
        </Row>

        <Row className={styles.row}>
          <Col span={4} className={styles.label}>
            Object
          </Col>
          <Col span={20} className={styles.value}>
            {data.after?.email ? (
              <NavLink to={`/users/${data.after.id}`}>
                {data.after.email}
              </NavLink>
            ) : data.before?.email ? (
              data.before.email
            ) : (
              "-"
            )}
          </Col>
        </Row>

        <Row className={styles.row}>
          <Col span={4} className={`${styles.label} ${styles.last}`}>
            Operation
          </Col>
          <Col
            span={20}
            className={`${styles.value} ${styles.last} capitalize-first-letter`}
          >
            {data.event}
          </Col>
        </Row>
      </div>

      <Table
        rowKey="field"
        pagination={false}
        columns={columns}
        dataSource={tableData}
        bordered
      />
    </PreviewDrawer>
  );
}
